import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityVincennesPage() {
  const data = citiesData.find((c) => c.slug === "vincennes")!;
  return <CityPage data={data} />;
}
